(function($){
  var isotope = {
    init: function(){
      if ($('.iso-grid').length){
        isotope.initIsotope();
      }
    },
    initIsotope: function(){

      $('.iso-grid').isotope({
        itemSelector: '.iso-item'
      });

      var $select_filter_internal = $('.select-filter.select-filter__internal');
      if($select_filter_internal.length) {

        $select_filter_internal.on('change', function() {
          var $this = $(this);

          if($this.attr('name') === "filter-1" || $this.attr('name') === "filter-2") {
            var current_level = parseInt($this.attr('name').substr(7));
            $select_filter_internal.attr('disabled', 'disabled');
            // $select_filter_internal.uniform('refresh');

            if($this.val()) {
              jQuery.post(
                ajaxurl,
                {'action': 'getthemelevel', '_wpnonce': $(this).attr('data-nonce'), 'tid': $(this).val()},
                function(response){
                  if(response.status === 'ok') {
                    $('.select-filter__internal[name="filter-1"]').attr('disabled', null);
                    $this.attr('disabled', null);
                    var $next = $('.select-filter__internal[name="filter-'+(current_level+1)+'"]');
                    $next.html('');
                    $next.append($('<option></option>').attr('value', '').text($next.attr('data-label')));
                    for(var i = 0 ; i < response.data.length ; i++)
                      $next.append($('<option></option>').attr('value', response.data[i].tid).text(response.data[i].name));
                    $next.attr('disabled', null);
                    // $select_filter_internal.uniform('refresh');
                  }
                }, 'json'
              );
            } else {
              $('.select-filter__internal[name="filter-1"]').attr('disabled', null);
              $this.attr('disabled', null);
              // $select_filter_internal.uniform('refresh');
            }
          }

          var filters = "*";
          $select_filter_internal.each(function(i, o) {
            if($(o).val() !== "")
              filters += '.term-'+$(o).val();
          });
          $('.iso-grid').isotope({ filter: filters });

        });
      }

      var $select_filter_external = $('.select-filter.select-filter__external');
      if($select_filter_external.length) {
        $select_filter_external.on('change', function() {
          window.location.href = $(this).val();
        });
      }

    }
  };
  $(document).ready(isotope.init);
})(jQuery);
